import React, { useState } from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import whyChooseImage from '../../../../assets/images/solutiondetails/whychoose/main.jpg';
import './WhyChoose.css';

const WhyChoose = ({ title, description, items, image }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (!title || !items?.length) {
    return null;
  }

  return (
    <section className="why-choose">
      <div className="why-choose__inner">
        <Reveal className="why-choose__copy">
          <h2 className="why-choose__title">{title}</h2>
          {description ? <p className="why-choose__text">{description}</p> : null}

          <ul className="why-choose__list">
            {items.map((item, index) => {
              const isActive = activeIndex === index;

              return (
                <li key={item.title}>
                  <button
                    type="button"
                    className={`why-choose__item${isActive ? ' why-choose__item--active' : ''}`}
                    onClick={() => setActiveIndex(index)}
                    aria-expanded={isActive}
                  >
                    <span className="why-choose__item-title">{item.title}</span>
                    {isActive && item.text ? (
                      <span className="why-choose__item-text">{item.text}</span>
                    ) : null}
                  </button>
                </li>
              );
            })}
          </ul>
        </Reveal>

        <Reveal className="why-choose__media" delay={80}>
          <img
            className="why-choose__image"
            src={image || whyChooseImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default WhyChoose;
